@if (initialized) {
  <section>
    <div class="mat-headline-5">Personal info</div>
    <div class="mat-headline-6">You can update your personal info, notification preferences on Sitenotes</div>
  </section>
  <section class="stroked-card">
    <form [formGroup]="inputForm">
      <div>
        <div class="mat-subtitle-1">Basic info</div>
        <div class="mat-headline-6">Some info (name, email, picture) may be visible to other people</div>
      </div>
      <section>
        <div class="mat-body-2">Photo</div>
        <div class="preview-list">
          @if (account.picture?.id) {
            <div>
              <img [src]="account.picture.getThumbnail()" />
              <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon" (click)="removePicture()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
          @if (!account.picture) {
            <app-file-uploader class="input-placeholder small" icon="image"
              accept="image/*" (complete)="onUploadComplete($event)">
            </app-file-uploader>
          }
        </div>
      </section>
      <section>
        <div class="mat-body-2">Name</div>
        <!-- First Name -->
        <mat-form-field>
          <mat-label>First name</mat-label>
          <input matInput type="text" autocomplete="off" formControlName="first_name" [errorStateMatcher]="matcher" />
          @if (inputForm.controls.first_name.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.controls.first_name.hasError('error')) {
            <mat-error>
              {{inputForm.controls.first_name.errors.error}}
            </mat-error>
          }
        </mat-form-field>
        <!-- /First Name -->
        <!-- Last Name -->
        <mat-form-field>
          <mat-label>Last name</mat-label>
          <input matInput type="text" autocomplete="off" formControlName="last_name" [errorStateMatcher]="matcher" />
          @if (inputForm.controls.last_name.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.controls.last_name.hasError('error')) {
            <mat-error>
              {{inputForm.controls.last_name.errors.error}}
            </mat-error>
          }
        </mat-form-field>
        <!-- /Last Name -->
      </section>
      <section>
        <div class="mat-body-2">Phone</div>
        <!-- Phone -->
        <mat-form-field>
          <input matInput type="text" autocomplete="off" formControlName="phone" [errorStateMatcher]="matcher" />
          @if (inputForm.controls.phone.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.controls.phone.hasError('error')) {
            <mat-error>
              {{inputForm.controls.phone.errors.error}}
            </mat-error>
          }
        </mat-form-field>
        <!-- /Phone -->
      </section>
      <section>
        <div class="mat-body-2">Email</div>
        <!-- Email -->
        <mat-form-field>
          <input matInput type="text" autocomplete="off" formControlName="email" [errorStateMatcher]="matcher" />
          @if (inputForm.controls.email.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.controls.email.hasError('error')) {
            <mat-error>
              {{inputForm.controls.email.errors.error}}
            </mat-error>
          }
        </mat-form-field>
        <!-- /Email -->
      </section>
      <section>
        <div class="mat-body-2">Locale</div>
        <mat-form-field>
          <mat-select formControlName="locale" [errorStateMatcher]="matcher">
            @for (locale of locales; track locale) {
              <mat-option [value]="locale">
                {{locale}}
              </mat-option>
            }
          </mat-select>
          @if (inputForm.controls.locale.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.controls.locale.hasError('error')) {
            <mat-error>
              {{inputForm.controls.locale.errors.error}}
            </mat-error>
          }
        </mat-form-field>
      </section>
      <section>
        <div class="mat-body-2">Offline support</div>
        <mat-slide-toggle formControlName="offline_support" (change)="onSubmit()"></mat-slide-toggle>
      </section>
      <div class="form-actions">
        <button mat-flat-button color="primary" (click)="onSubmit()">Update basic info</button>
      </div>
    </form>
  </section>
  @if (account?.organization?.ai_chat_enabled) {
    <section class="stroked-card">
      <form [formGroup]="inputForm">
        <div>
          <div class="mat-subtitle-1">AI Assistant</div>
          <div class="mat-headline-6">The AI Assistant uses Anthropic's Claude to answer questions about your project data</div>
        </div>
        <section>
          <div class="mat-body-2">AI data processing consent</div>
          <div class="toggle-with-description">
            <mat-slide-toggle formControlName="ai_chat_consent" (change)="onSubmit()"></mat-slide-toggle>
            <span class="toggle-description">Allow project data to be sent to Anthropic's API for AI processing</span>
          </div>
        </section>
      </form>
    </section>
  }
  <section class="stroked-card">
    <form [formGroup]="inputForm">
      <div>
        <div class="mat-subtitle-1">Notification preferences</div>
        <div class="mat-headline-6">Configure your notification settings here</div>
      </div>
      <section>
        <div class="mat-body-2">SMS notifications</div>
        <div class="toggle-with-description">
          <mat-slide-toggle formControlName="sms_notifications" (change)="onSubmit()"></mat-slide-toggle>
          <span class="sms-consent mat-caption" data-testid="profile-sms-consent">
            Get project notification texts from Sitenotes at your account phone number. Message frequency varies with project activity.
            Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.
            <a href="https://www.sitenotesapp.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> &middot;
            <a href="https://www.sitenotesapp.com/terms" target="_blank" rel="noopener">Terms of Service</a>
          </span>
        </div>
      </section>
      <section>
        <div class="mat-body-2">Push notifications</div>
        <mat-slide-toggle formControlName="push_notifications" (change)="onSubmit()"></mat-slide-toggle>
      </section>
      <section>
        <div class="mat-body-2">Email notifications</div>
        <mat-slide-toggle formControlName="email_notifications" (change)="onSubmit()"></mat-slide-toggle>
      </section>
    </form>
  </section>
  <section class="stroked-card">
    <form [formGroup]="passwordForm">
      <div>
        <div class="mat-subtitle-1">
          @if (account.has_password) {
            Change password
          }
          @if (!account.has_password) {
            Set password
          }
        </div>
      </div>
      <section>
        <div class="mat-body-2">Password</div>
        <!-- password -->
        <mat-form-field>
          <mat-label>Type in new password</mat-label>
          <input matInput type="password" autocomplete="off" formControlName="password" [errorStateMatcher]="matcher" />
          @if (passwordForm.controls.password.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (passwordForm.controls.password.hasError('error')) {
            <mat-error>
              {{passwordForm.controls.password.errors.error}}
            </mat-error>
          }
        </mat-form-field>
        <!-- /password -->
      </section>
      <div class="form-actions">
        <button mat-flat-button color="primary" (click)="updatePassword()">Update password</button>
      </div>
    </form>
  </section>
}
